import Cookies from 'js-cookie'

// http 环境（如 localhost 开发）下不能带 Secure / SameSite=None：
// Safari 不把 http://localhost 视为安全上下文，会直接丢弃这类 cookie，
// 导致 getToken() 取不到值、请求头 token 为空。故按当前协议动态决定。
// 生产为 HTTPS 时结果与原逻辑完全一致（secure: true, sameSite: 'None'）。
const isHttps = typeof window !== 'undefined' && window.location.protocol === 'https:'
const CookieOpts = {
  secure: isHttps,
  sameSite: isHttps ? 'None' : 'Lax'
}

const TokenKey = 'hbwzndcfhuhaqlum'
const RoleKey = 'idjwd41104l4'
const NickNameKey = 'yx733n4dnfxv'
const AccountKey = 'g1jvgy5zi84k'
const UidKey = 'sdalfisnsnd'
const HeadimgKey = 'jvsksajfnna'
const pushExcelKey = 'asdsjakfsas'
const UuidKey = 'aiuyusnjshfnk'


export function getUuid() {
  return Cookies.get(UuidKey)
}

export function setUuid(uuid) {
  return Cookies.set(UuidKey, uuid, CookieOpts);
}

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token, CookieOpts);
}

export function setUid(uid) {
  return Cookies.set(UidKey, uid, CookieOpts)
}

export function getRole() {
  return Cookies.get(RoleKey)
}

export function getUid() {
  return Cookies.get(UidKey)
}

export function setRole(role) {
  return Cookies.set(RoleKey, role, CookieOpts)
}

export function getNickname() {
  return Cookies.get(NickNameKey)
}

export function setNickname(name) {
  return Cookies.set(NickNameKey, name, CookieOpts)
}

export function getAccount() {
  return Cookies.get(AccountKey)
}

export function setAccount(name) {
  return Cookies.set(AccountKey, name, CookieOpts)
}

export function getHeadimg() {
  return Cookies.get(HeadimgKey)
}

export function setHeadimg(name) {
  return Cookies.set(HeadimgKey, name, CookieOpts)
}

export function pushExcel(value) {
  return Cookies.set(pushExcelKey, value, CookieOpts)
}

export function getExcel() {
  return Cookies.get(pushExcelKey)
}

export function removeToken() {
  Cookies.remove(TokenKey)
  Cookies.remove(RoleKey)
  Cookies.remove(AccountKey)
  Cookies.remove(UidKey)
  Cookies.remove(HeadimgKey)
  Cookies.remove(pushExcelKey)
  return Cookies.remove(NickNameKey)
}
